import { DialogActions, Grid, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CheckCircle } from '@mui/icons-material';
import { TwoPaneModalContent } from '../../../../../../ui/components/pure/modal-content/two-pane-modal-content.component';
import { TextButton } from '../../../../../../ui/components/pure/text-button/text-button.component';
import { useBookOrderActionContext } from '../book-order-action.context';
import { AllStepsLeftSide } from '../shared-components/all-steps-left-side/all-steps-left-side.component';
import { SectionTitle } from '../shared-components/section-title/section-title.component';

export function BookingCompletedStep() {
  const { state, handlers } = useBookOrderActionContext();
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down('sm'));

  if (state.current !== 'BOOKING_COMPLETED') {
    return null;
  }

  const formattedOrderNumber = state.order.orderNumber ? `Order #${state.order.orderNumber}` : 'Order';
  const bookAnotherButtonText = state.order.customer?.firstName
    ? `More for ${state.order.customer.firstName}`
    : 'Book Another';

  return (
    <>
      <TwoPaneModalContent
        leftDesktopWidth={4}
        rigthDesktopWidth={8}
        flexibleWidthPane="right"
        leftContent={() => <AllStepsLeftSide disableProjectSelector />}
        rightContent={() => (
          <Grid
            container
            style={{ padding: '8px', width: '100%', margin: 0 }}
            spacing={3}
            sx={{
              alignItems: 'center',
              flexDirection: 'column'
            }}
          >
            <Grid>
              <SectionTitle value="Order Booked" />
            </Grid>

            <Grid>
              <CheckCircle style={{ fontSize: 64, color: theme.palette.success.main }} />
            </Grid>

            <Grid>
              <Typography variant="body1" align="center">
                {formattedOrderNumber} has been booked successfully.
              </Typography>
            </Grid>

            {state.order.customer && (
              <Grid>
                <Typography variant="body2" align="center" color="textSecondary">
                  Customer: {state.order.customer.firstName} {state.order.customer.lastName}
                </Typography>
              </Grid>
            )}
          </Grid>
        )}
      />

      <DialogActions style={{ borderTop: '1px solid #EBEDF2', padding: '16px 24px' }}>
        <Grid
          container
          spacing={2}
          wrap="nowrap"
          sx={{
            justifyContent: 'space-between'
          }}
        >
          <Grid
            size={{
              xs: 6,
              sm: 'auto'
            }}
          >
            <TextButton color="secondary" variant="outlined" fullWidth={isXs} onClick={handlers.onBookAnother}>
              {bookAnotherButtonText}
            </TextButton>
          </Grid>
          <Grid
            size={{
              xs: 6,
              sm: 'auto'
            }}
          >
            <TextButton color="primary" variant="outlined" fullWidth={isXs} onClick={handlers.onBookingComplete}>
              Done
            </TextButton>
          </Grid>
        </Grid>
      </DialogActions>
    </>
  );
}
